<template>
  <div class="screen">
    <div class="cover">
      <img v-if="cover" :src="cover" :alt="content.title || ''" class="cover-image" />
      <img
        v-else
        :src="'/static/icons/article-preview-default.svg'"
        class="cover-default"
        alt=""
      />
    </div>
    <div class="detail">
      <div v-if="content.type" class="type">
        {{ $t(`feature.article.category.${content.type}`) }}
      </div>
      <div class="title">
        {{ content.title || $t("label.title") }}
      </div>
      <div class="date">
        {{ previewDate | moment-full }}
      </div>
      <hr />
      <div v-safe-html="content.body" class="contents"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    cover: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      previewDate: new Date(),
    };
  }
};
</script>

<style lang="scss" scoped>
.cover {
  background-color: #8c8786;
  margin: 0 auto;
  overflow: hidden;
  border-bottom: 1px solid #eee;
  border-radius: 12px 12px 0 0;

  &-default {
    position: relative;
    width: 70px;
    margin: 35px;
    top: calc(50% - 35px);
  }
  &-image {
    position: relative;
    width: 100%;
    object-fit: fill;
  }
}
.detail {
  padding: 16px 20px;
}
.type {
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #ef7e18;
}
.title {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -0.1px;
  text-align: left;
  color: #000000;
}
.date {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: left;
  color: #616161;
}
hr {
  width: 40%;
}
.contents {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
p {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
a {
  color: #ff0000;
}
</style>
